module.exports = __webpack_public_path__ + "img/proyecto_18.407e5a91.png";